<template>
  <cs-view single-view>
    <template #content>
      <v-expansion-panels variant="accordion">
        <v-expansion-panel>
          <v-expansion-panel-title class="title-1">CSButton</v-expansion-panel-title>
          <v-expansion-panel-text>
            <buttons-test />
          </v-expansion-panel-text>
        </v-expansion-panel>
        <v-expansion-panel>
          <v-expansion-panel-title class="title-1"
            >CSIllustrationSvgSelector</v-expansion-panel-title
          >
          <v-expansion-panel-text>
            <cs-illustration-selector-test />
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
  </cs-view>
</template>
<script>
import { mapMutations } from 'vuex';
import { CSBase } from '@complispace/cs-design-system';
import * as types from '../store/mutationTypes';
import ButtonsTest from '../components/ButtonsTest';
import CSIllustrationSelectorTest from '../components/CSIllustrationSelectorTest';

export default {
  name: 'FormControls',

  components: {
    'buttons-test': ButtonsTest,
    'cs-illustration-selector-test': CSIllustrationSelectorTest
  },

  extends: CSBase,

  data() {
    return {};
  },
  computed: {},
  async mounted() {
    this.setPageViewType('form-controls');
  },
  methods: {
    ...mapMutations({
      setPageViewType: types.VIEW_TYPE_SET_PAGE_VIEW_TYPE
    })
  }
};
</script>

<style scoped></style>
